export default __webpack_public_path__ + "static/media/face.4c1ce6ef.png";